import { Link } from "react-router-dom";
import bitsfar from "../../assets/Image/binaxpay.png";

const AuthBranding = ({
  titlePrefix = "",
  accentText = "",
  titleSuffix = "",
  subtitle = "",
  features = [],
}) => {
  return (
    <div className="auth-content">
      <div className="logo mb-4">
        <Link to="/">
          <img src={bitsfar} alt="Binaxpay Logo" />
        </Link>
      </div>
      <div className="auth-heading">
        <h1>
          {titlePrefix && <span>{titlePrefix} </span>}
          {accentText && <span className="accent">{accentText}</span>}
          {titleSuffix && <span> {titleSuffix}</span>}
        </h1>
        {subtitle && <p>{subtitle}</p>}
      </div>

      {features && features.length > 0 && (
        <div className="auth-features">
          {features.map((item, index) => (
            <div className="feature-item" key={index}>
              <span className="feature-icon-ring me-3">{item.icon}</span>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AuthBranding;
